import Axios from 'axios';

Axios.defaults.baseURL = import.meta.env.VITE_APP_BACKEND_API_URL;

const scope = import.meta.env.VITE_APP_BACKEND_API_SCOPE as string;

export const fetcher = async (
  url: string,
  getAccessToken: (scopes: string[]) => Promise<string>
) => {
  const token = await getAccessToken([scope]);

  const res = await Axios.get(url, {
    headers: { Authorization: `Bearer ${token}` }
  });

  return res.data;
};

export const headRequest = async (
  url: string,
  getAccessToken: (scopes: string[]) => Promise<string>
) => {
  try {
    const token = await getAccessToken([scope]);
    const response = await Axios.head(url, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.status === 200;
  } catch (error) {
    if (Axios.isAxiosError(error)) {
      // eslint-disable-next-line no-console
      console.error('Request failed:', error.response?.status, error.message);
    } else {
      // eslint-disable-next-line no-console
      console.error('Unexpected error:', error);
    }
    throw error;
  }
};
